import {
  readNetlifyErrorMessage,
} from './netlifyClient';
import tokenService from '../utils/tokenService';

export interface RestrictedAccessAdminSettings {
  enabled: boolean;
}

class RestrictedAccessAdminService {
  private async buildHeaders(): Promise<Record<string, string>> {
    const token = await tokenService.getToken();
    if (!token) {
      throw new Error('Session invalide: token manquant.');
    }

    return {
      'Content-Type': 'application/json',
      'X-Client-Token': token,
    };
  }

  public async getSettings(): Promise<RestrictedAccessAdminSettings> {
    const response = await fetch('/.netlify/functions/restricted-access-admin', {
      method: 'GET',
      headers: await this.buildHeaders(),
    });

    if (!response.ok) {
      throw new Error(await readNetlifyErrorMessage(response, `Echec lecture reglage (${response.status})`));
    }

    const body = await response.json().catch(() => ({})) as { enabled?: boolean };
    return {
      enabled: body?.enabled === true,
    };
  }

  public async updateSettings(enabled: boolean): Promise<RestrictedAccessAdminSettings> {
    const response = await fetch('/.netlify/functions/restricted-access-admin', {
      method: 'POST',
      headers: await this.buildHeaders(),
      body: JSON.stringify({ enabled }),
    });

    if (!response.ok) {
      throw new Error(await readNetlifyErrorMessage(response, `Echec mise a jour reglage (${response.status})`));
    }

    const body = await response.json().catch(() => ({})) as { enabled?: boolean };
    return {
      enabled: body?.enabled === true,
    };
  }
}

export const restrictedAccessAdminService = new RestrictedAccessAdminService();
